export default {"src":"/_next/static/media/integration-ux-ui-objects-bg.9b332292.svg","height":513,"width":149,"blurWidth":0,"blurHeight":0};